const isChrome =
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.location.href.indexOf("sarv") > -1;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isIphone = /(iPhone|iPad)/i.test(navigator.userAgent) || window.location.href.indexOf("sarv") > -1;;

const isAndroidDesktopMode = () => {
  const ua = navigator.userAgent;
  const isAndroid = /Android/i.test(ua);
  const isLinux = /Linux/i.test(navigator.platform);
  const hasTouch = navigator.maxTouchPoints > 0;

  // Linux + Touch + No "Android" in UA usually means Android Desktop Mode
  return !isAndroid && isLinux && hasTouch;
};

export { isChrome, isMobile, isSafari, isIphone, isAndroidDesktopMode };
